









import Vue from "vue";
export default Vue.extend({
  name: "SearchBox",
  props: {
    map: {
      type: Object,
      required: true
    },
    google: {
      type: Object,
      required: true
    }
  },

  mounted(): void {
    const searchBox = new this.google.maps.places.SearchBox(
      this.$refs.searchBox
    );

    this.map.addListener("bounds_changed", () => {
      searchBox.setBounds(this.map.getBounds());
    });

    searchBox.addListener("places_changed", () => {
      const places = searchBox.getPlaces();

      if (places.length == 0) {
        return;
      }

      // For each place, get the icon, name and location.
      const bounds = new this.google.maps.LatLngBounds();
      places.forEach(place => {
        if (!place.geometry) {
          // console.log("Returned place contains no geometry");
          return;
        }

        if (place.geometry.viewport) {
          // Only geocodes have viewport.
          bounds.union(place.geometry.viewport);
        } else {
          bounds.extend(place.geometry.location);
        }
      });
      this.map.fitBounds(bounds);
    });
  }
});
